var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_1784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7C7.25 9.75833 9.49167 12 12.25 12C15.0083 12 17.25 9.75833 17.25 7C17.25 6.77917 17.2292 6.56667 17.2042 6.35417C17.2042 6.32083 17.1958 6.29167 17.1875 6.25833C16.8292 3.85417 14.7542 2 12.25 2C10.4 2 8.78333 3.0125 7.91667 4.5125C7.91667 4.52083 7.90833 4.525 7.90417 4.53333C7.49167 5.2625 7.25 6.1 7.25 6.99583V7ZM12.25 10.75C10.1833 10.75 8.5 9.06667 8.5 7C8.5 6.5875 8.57083 6.19167 8.69167 5.82083C10.0958 6.975 11.875 7.625 13.7042 7.625H13.7083C14.4875 7.625 15.2458 7.50833 15.9833 7.2875C15.8375 9.22083 14.2208 10.75 12.2458 10.75H12.25ZM12.25 3.25C13.975 3.25 15.425 4.42083 15.8625 6.00833C15.1708 6.24583 14.45 6.375 13.7083 6.375C12.0875 6.375 10.5083 5.7625 9.30417 4.69167C9.99167 3.81667 11.0583 3.25 12.2542 3.25H12.25Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6333 13.3083C15.6125 13.3 15.5917 13.2917 15.5667 13.2833C14.5417 12.8625 13.425 12.625 12.25 12.625C11.075 12.625 9.95417 12.8625 8.93333 13.2833C8.9125 13.2917 8.8875 13.2958 8.86667 13.3083C5.71667 14.6333 3.5 17.75 3.5 21.375C3.5 21.7208 3.77917 22 4.125 22C4.47083 22 4.75 21.7208 4.75 21.375C4.75 18.6 6.27083 16.175 8.52083 14.8792C8.7125 16.7708 10.3125 18.25 12.25 18.25C14.1875 18.25 15.7917 16.7708 15.9792 14.8792C18.2292 16.175 19.75 18.6 19.75 21.375C19.75 21.7208 20.0292 22 20.375 22C20.7208 22 21 21.7208 21 21.375C21 17.75 18.7833 14.6333 15.6333 13.3083ZM14.75 14.5C14.75 15.8792 13.6292 17 12.25 17C10.8708 17 9.75 15.8792 9.75 14.5V14.3125C10.5333 14.0333 11.3708 13.875 12.25 13.875C13.1292 13.875 13.9667 14.0333 14.75 14.3125V14.5Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_1784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white",
    transform: "translate(3.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.66da7c30d43053a13f30b6f1f3e21d94.svg";
export { ForwardRef as ReactComponent };